export enum SearchSubTermTypeEnum {
    Action = "ACTION",
    Object = "OBJECT",
    Specification = "SPECIFICATION",
    Unit = "UNIT",
    UnitValue = "UNIT_VALUE",
    MaximumUnitValue = "MAXIMUM_UNIT_VALUE"
}
